<template>
  <div id="circleItemComp" @click="$emit('click')">
    <van-image class="thumb" :src="detail.coverImage" fit="cover"></van-image>
    <div class="content"  >
      <div class="title">
        <div class="name text-ellipsis">{{detail.name}}</div>
        <div class="sub text-ellipsis">{{detail.brief}}</div>
      </div>
      <div class="record">
        <div class="item">
          <span class="label">关注</span>
          <span class="value">{{detail.followers}}</span>
        </div>
        <div class="item" v-if="false">
          <span class="label">问题</span>
          <span class="value">{{detail.followers}}</span>
        </div>
      </div>
    </div>
    <div class="btns">
      <button class="btn btn-1" v-if="detail.follow" @click.stop.prevent="$emit('handleButton')">已关注</button>
      <button class="btn btn-2" v-else @click.stop.prevent="$emit('handleButton')">关注</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CircleItemComp',
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
@color-999AAA: #999AAA;
@color-5FA9FF: #5FA9FF;
#circleItemComp {
  padding: 40px 26px;
  display: flex;
  position: relative;
  .thumb {
    width: 146px;
    height: 146px;
    flex-shrink: 0;
    border-radius: 8px;
    overflow: hidden;
  }
  .content {
    width: 0;
    flex:1;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      .name {
        font-weight: bold;
        line-height: 36px;
        font-size: 26px;
        color: #333444;
      }
      .sub {
        line-height: 32px;
        font-size: 22px;
        color: @color-999AAA;
        margin-top: 4px;
      }
    }
    .record {
      display: flex;
      align-items: center;
      .item {
        font-size: 24px;
        position: relative;
        color: @color-999AAA;
        .value {
          color: #333444;
          font-weight: bold;
          margin-left: 8px;
        }
        &:not(:last-child){
          padding-right: 40px;
          &:after{
            content: '';
            width: 2px;
            height: 20px;
            background-color: #DDDEE6;
            position: absolute;
            top: 0;
            left: 20px;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
  .btns {
    width: 116px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    .btn {
      width: 116px;
      height: 46px;
      background-color: #FFFFFF;
      border-radius: 40px;
      font-size: 24px;
      border: 2px solid transparent;
      &.btn-1 {
        border-color: @color-999AAA;
        color: @color-999AAA;
      }
      &.btn-2 {
        border-color: @primaryGreen;
        color: @primaryGreen;
      }
    }
  }
  &:after {
    content: '';
    width: calc(100% - 52px);
    height: 2px;
    background-color: #F0F0F0;
    position: absolute;
    left: 26px;
    bottom: 0;
  }
}
</style>